// src/admin/DataMigration/DataMigrationManager.js
import React, { useState } from 'react';
import StudentProfileCsvTool from './tools/StudentProfileCsvTool';
import StudentAttendanceTool from './tools/StudentAttendanceTool';
import CatechistIdTool from './tools/CatechistIdTool';
import './DataMigrationManager.css';

const DataMigrationManager = () => {
  const [activeTab, setActiveTab] = useState('catechist_id'); // 'profile' | 'attendance' | 'catechist_id'
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('idle'); // 'idle' | 'processing' | 'done' | 'error'
  const [terminalLog, setTerminalLog] = useState('');

  const isProcessing = status === 'processing';

  return (
    <div className="data-migration-manager">
      <div className="dmm-card">
        <h2 className="dmm-title">Trung Tâm Di Trú & Cập Nhật Dữ Liệu</h2>
        <p className="dmm-subtitle">
          Quản lý bổ sung sơ yếu lý lịch, cấu trúc điểm danh và chuẩn hóa mã định danh Giáo lý viên.
        </p>

        {/* TAB ĐIỀU HƯỚNG CÔNG CỤ */}
        <div className="dmm-nav-tabs">
          <button 
            className={`dmm-tab-btn ${activeTab === 'catechist_id' ? 'active' : ''}`}
            onClick={() => setActiveTab('catechist_id')}
          >
            🆔 Đổi ID Giáo Lý Viên
          </button>
          <button 
            className={`dmm-tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('profile')}
          >
            📋 Bổ Sung Sơ Yếu Lý Lịch (Từ CSV)
          </button>
          <button 
            className={`dmm-tab-btn ${activeTab === 'attendance' ? 'active' : ''}`}
            onClick={() => setActiveTab('attendance')}
          >
            ⚡ Tối Ưu Cấu Trúc Điểm Danh
          </button>
        </div>

        {/* NỘI DUNG TỪNG CÔNG CỤ TÁCH RỜI */}
        {activeTab === 'catechist_id' && (
          <CatechistIdTool 
            setProgress={setProgress}
            setStatus={setStatus}
            setTerminalLog={setTerminalLog}
            isProcessing={isProcessing}
          />
        )}

        {activeTab === 'profile' && (
          <StudentProfileCsvTool 
            setProgress={setProgress}
            setStatus={setStatus}
            setTerminalLog={setTerminalLog}
            isProcessing={isProcessing}
          />
        )}

        {activeTab === 'attendance' && (
          <StudentAttendanceTool 
            setProgress={setProgress}
            setStatus={setStatus}
            setTerminalLog={setTerminalLog}
            isProcessing={isProcessing}
          />
        )}

        {/* THANH TIẾN TRÌNH DÙNG CHUNG */}
        {status === 'processing' && (
          <div className="dmm-progress-panel">
            <div className="dmm-progress-track">
              <div className="dmm-progress-bar" style={{ width: `${progress}%` }}></div>
            </div>
            <div className="dmm-progress-percentage">Tiến độ thực hiện: <strong>{progress}%</strong></div>
          </div>
        )}

        {/* TERMINAL LOG HIỂN THỊ DÙNG CHUNG */}
        {terminalLog && (
          <textarea 
            readOnly 
            value={terminalLog} 
            className="dmm-terminal-view"
            placeholder="Log tiến trình..."
          />
        )}
      </div>
    </div>
  );
};

export default DataMigrationManager;